import React from "react";
import { useClasses } from "../../../api/class.api";
import styles from "./RuleClassesAction.module.scss";

interface Props {
    value: string[];
}

export const RuleClassesAction: React.FC<Props> = ({ value }) => {
    const { classesMap } = useClasses();

    // Filter out any invalid class IDs
    const classes = value
        .map((id) => classesMap.get(id))
        .filter((c): c is NonNullable<typeof c> => c !== undefined);

    if (!classes.length) {
        return null;
    }

    return (
        <div className={styles.container}>
            <span>
                Set Classes{" "}
                <span className={styles.classList}>
                    {classes.map((c) => c.label).join(", ")}
                </span>
            </span>
        </div>
    );
};
